import React from 'react'
import clsx from 'clsx'
import Link from 'next/link'

import Icon from '~/truck/icon'
import NewButton from '~/truck/new-button/NewButton'

interface SuccessStateProps {
  style?: React.CSSProperties
  className?: string
  code: string
}

function SuccessState({ style, className, code }: SuccessStateProps) {
  return (
    <div className={clsx('flex flex-col items-center', className)} style={style}>
      <p className="text-center text-3xl font-bold">
        Gracias por tu comunicación
        <br />
        <span className="text-xl font-normal">hemos recibido tus datos</span>
      </p>
      <div className="mt-4 rounded bg-neutral-100 px-4 py-2">
        <span className="text-sm font-semibold">Código de reclamo: </span>
        <span className="text-sm">{code}</span>
      </div>
      <div className="relative my-8 flex">
        <Icon
          className="absolute right-0 top-0 -translate-y-1/2 translate-x-1/2"
          type="check"
          color="success"
          size="xl"
        />
        <Icon className="size-32" type="document" color="black" />
      </div>
      <NewButton asChild className="w-44">
        <Link href="/">Continuar</Link>
      </NewButton>
    </div>
  )
}

export default SuccessState
